'use es6';

import { Component } from 'react';
import ResultHeader from './ResultHeader';
import ResultInfo from './ResultInfo';
import ResultSection from './ResultSection';
import Tag from './Tag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class IconResultSection extends Component {
  render() {
    const {
      props
    } = this;
    return /*#__PURE__*/_jsxs(ResultSection, {
      gradeType: props.gradeType,
      children: [/*#__PURE__*/_jsx(Tag, Object.assign({}, props)), /*#__PURE__*/_jsx(ResultHeader, Object.assign({}, props)), /*#__PURE__*/_jsx("div", {
        className: `result-icon icon ${props.resultIcon}`
      }), /*#__PURE__*/_jsx(ResultInfo, Object.assign({}, props))]
    });
  }
}